<template>
  <div style="width: 100%;" :style="{height: size == 7 ? '100vw' : '100%'}">
    <!-- 单图 -->
    <div class="advertising-item-1" style="position: relative;" v-if="size == 1">
      <img :src="adverArray[0].url" style="width: 100%; height: 100%;" @click="goNext(adverArray[0])" />
    </div>

    <!-- 一排两个 -->
    <div class="advertising-item-2" :style="{height: bigHeight + 'px'}" v-if="size == 2">
      <div class="advertising-item-image" v-if="adverArray[0]">
        <img :src="adverArray[0].url" class="advertising-item-image-img" style="width: 100%; height: 100%;" @click="goNext(adverArray[0])" id="2-1" @load="imageLoad" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[1]">
        <img :src="adverArray[1].url" class="advertising-item-image-img" style="width: 100%; height: 100%;" @click="goNext(adverArray[1])" id="2-2" @load="imageLoad" />
      </div>
    </div>

    <!-- 一排三个 -->
    <div class="advertising-item-3" :style="{height: bigHeight + 'px'}" v-if="size == 3">
      <div class="advertising-item-image" v-if="adverArray[0]">
        <img :src="adverArray[0].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[0])" id="3-1" @load="imageLoad" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[1]">
        <img :src="adverArray[1].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[1])" id="3-2" @load="imageLoad" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[2]">
        <img :src="adverArray[2].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[2])" id="3-3" @load="imageLoad" />
      </div>
    </div>

    <!-- 左一右二 -->
    <div class="advertising-item-4" v-if="size == 4">
      <div class="advertising-item-image width-50" v-if="adverArray[0]" style="height: 50vw">
        <img :src="adverArray[0].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[0])" />
      </div>
      <div class="width-50">
        <div class="advertising-item-image" style="height: 25vw; width: 100%;" v-if="adverArray[1]">
          <img :src="adverArray[1].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[1])" />
        </div>
        <div class="advertising-item-image" style="height: 25vw; width: 100%;" v-if="adverArray[2]">
          <img :src="adverArray[2].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[2])" />
        </div>
      </div>
    </div>

    <!-- 一排四个 -->
    <div class="advertising-item-5" :style="{height: bigHeight + 'px'}" v-if="size == 5">
      <div class="advertising-item-image" v-if="adverArray[0]">
        <img :src="adverArray[0].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[0])" id="4-1" @load="imageLoad" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[1]">
        <img :src="adverArray[1].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[1])" id="4-2" @load="imageLoad" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[2]">
        <img :src="adverArray[2].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[2])" id="4-3" @load="imageLoad" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[3]">
        <img :src="adverArray[3].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[3])" id="4-4" @load="imageLoad" />
      </div>
    </div>

    <!-- 四宫格 -->
    <div class="advertising-item-6" v-if="size == 6">
      <div class="advertising-item-image" v-if="adverArray[0]">
        <img :src="adverArray[0].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[0])" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[1]">
        <img :src="adverArray[1].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[1])" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[2]">
        <img :src="adverArray[2].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[2])" />
      </div>
      <div class="advertising-item-image" v-if="adverArray[3]">
        <img :src="adverArray[3].url" class="advertising-item-image-img" style="width: 100%; height: 100%" @click="goNext(adverArray[3])" />
      </div>
    </div>

    <!-- 魔方宫格 -->
    <div v-if="size == 7" class="rubik-cube">
      <div v-for="(item, index) in adverArray" :key="index">
        <div
          class="rubik-cube__item"
          :key="index"
          :style="{
            width: getWidth(item) + 'px',
            height: getHeight(item) + 'px',
            top: getTop(item) + 'px',
            left: getLeft(item) + 'px'
          }"
        >
          <img v-if="item.url" :src="item.url" style="width: 100%; height: 100%" @click="goNext(item)" />
          <img v-else src="https://zk-micro.oss-cn-hangzhou.aliyuncs.com/wfw_package_img_bg.png" style="width: 100%; height: 100%" @click="goNext(item)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgheights: [],
      bigHeight: ''
    }
  },
  props: {
    facade: {
      type: [Object, Array]
    },
    content: {
      type: [Object, Array]
    }
  },
  computed: {
    adverArray() {
      return this.content.data;
    },
    size() {
      return this.content.style;
    },
    windowWidth() {
      return window.innerWidth || 750;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    imageLoad(e) { //当图片载入完毕时
      if (e.target) {
        var imgwidth = e.target.width,
          imgheight = e.target.height,
          ratio = imgwidth / imgheight; //宽高比

        let width = this.windowWidth / e.target.id.split('-')[0]
        this.imgheights = this.imgheights.concat(width / ratio) // 计算的高度值
        this.bigHeight = Math.max.apply(null, this.imgheights.map(item => item))
      }
      console.log('最大的图片高度：', this.bigHeight, this.imgheights)
    },
    getHeight(item) {
      const width = this.windowWidth / this.content.density;
      return (item.rowEnd - item.rowStart + 1) * width;
    },
    getWidth(item) {
      const width = this.windowWidth / this.content.density;
      return (item.columnEnd - item.columnStart + 1) * width;
    },
    getLeft(item) {
      const width = this.windowWidth / this.content.density;
      return (item.columnStart - 1) * width;
    },
    getTop(item) {
      const width = this.windowWidth / this.content.density;
      return (item.rowStart - 1) * width;
    },
    goNext(item) {
      this.$emit('go-next', item.link)
    }
  }
}
</script>

<style lang="scss" scoped>
.rubik-cube {
  position: relative;
  width: 100vw;
  height: 100vw;
  font-size: 28px;

  .rubik-cube__item {
    position: absolute;
  }
}

.advertising {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 12px;
  zoom: 0.5;
}

.advertising-item-1 {
  position: relative;
  text-align: center;
  font-weight: 400;
  color: #8c8c8c;
  width: 100%;
  margin-bottom: -4px;

  &-img {
    width: 100%;
    height: auto;
  }
}

.advertising-item-2 {
  position: relative;
  width: 100%;
  display: flex;

  .advertising-item-image {
    flex: 1 1 auto;
    position: relative;
    width: calc(100% / 2);

    .advertising-item-image-img {
      width: 100%;
      height: auto;
    }
  }
}

.advertising-item-3 {
  position: relative;
  width: 100%;
  display: flex;

  .advertising-item-image {
    // flex: 1 1 1;
    position: relative;
    width: calc(100% / 3);

    .advertising-item-image-img {
      width: 100%;
      height: auto;
    }
  }
}

.advertising-item-4 {
  width: 100%;
  height: 50vw;
  display: flex;
  
  .width-50{
    width: 50%;
  }
  
  .advertising-item-image {
    position: relative;
    height: 100%;

    .advertising-item-image-img {
      width: 100%;
      height: 100%;
    }
  }
}

.advertising-item-5 {
  position: relative;
  width: 100%;
  display: flex;
  
  .advertising-item-image {
    flex: 1 1 1 1;
    width: 187.5px;
    position: relative;

    .advertising-item-image-img {
      width: 100%;
      height: auto;
    }
  }
}
  
.advertising-item-6 {
  width: 100%;
  height: 100vw;
  display: flex;
  flex-wrap: wrap;

  .advertising-item-image {
    position: relative;
    width: 50%;
    height: 50%;

    .advertising-item-image-img {
      width: 100%;
      height: 100%;
    }
  }
}
.img-4{
  grid-row: 1 / 3;
}
</style>